import { render, staticRenderFns } from "./businessInfo.vue?vue&type=template&id=3d2c25f4"
import script from "./businessInfo.vue?vue&type=script&lang=js"
export * from "./businessInfo.vue?vue&type=script&lang=js"
import style0 from "./businessInfo.vue?vue&type=style&index=0&id=3d2c25f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports